import { apiConfigsCielo, apiConfigsCieloLog, apiConfigsCieloInitializer } from './api';
import { bodyBrowser, bodyLog } from './constants';
import { bpmpi_load } from '../scripts/cielo/client';

export const init = bpmpi_load;

export const initOrder = async (token) => {
  const response = await apiConfigsCieloInitializer.post("V1/Order/JWT/Init", {
    BrowserPayload: {
      Order: {
        OrderDetails: {},
        Consumer: {
          BillingAddress: {},
          ShippingAddress: {},
          Account: {}
        },
        Cart: [],
        Token: {},
        Authorization: {},
        Options: {},
        CCAExtension: {}
      },
      SupportsAlternativePayments: {
        cca: true,
        hostedFields: false,
        applepay: false,
        discoverwallet: false,
        wallet: false,
        paypal: false,
        visacheckout: false
      }
    },
    Client: {
      Agent: "SongbirdJS",
      Version: "1.35.0"
    },
    ConsumerSessionId: "1_9084d230-ad6e-46d2-bbbc-c914f4d5c343",
    ServerJWT: token,
  })

  return response.data
}

export const configBrowser = async () => {
  await apiConfigsCielo.post("V2/Browser/SaveBrowserData", {
    bodyBrowser
  })
}

export const logCielo = async () => {
  await apiConfigsCieloLog.post("stag/log", {
    bodyLog
  })
}